import { useSelector } from "react-redux";
import {
    AplicativoReducerActions
} from "./Aplicativo";

export const useAplicativo = () => {
    // @ts-ignore
    const state = useSelector(state => state.aplicativoReducer);
    return {
        actions: {
            ...AplicativoReducerActions
        },
        state: state
    };
};